import WorkingHoursAddForm from './WorkingHoursAddForm';

export default WorkingHoursAddForm;
